import { render } from "./ImportFunction.vue?vue&type=template&id=ce909cc0&scoped=true"
import script from "./ImportFunction.vue?vue&type=script&lang=js"
export * from "./ImportFunction.vue?vue&type=script&lang=js"

import "./ImportFunction.vue?vue&type=style&index=0&id=ce909cc0&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce909cc0"]])

export default __exports__